export type Coord = { x: number; y: number };

export enum CELL_TYPES {
  CELL = 1,
  WALL,
  WAY,
  DESTINATION,
}
